<div class="budget-name">
  <span class="status">[{{ BudgetStatusLabel[budgetStatus] }}]</span>
  <span class="name">{{ budgetName }}</span>
</div>
